module.exports = __webpack_public_path__ + "static/media/lb.de6c06cd.svg";